import type { SVGProps } from "react"

import { Spinner } from "@/components/ui/spinner"

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="12 12 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      d="M27.0588 20C27.0588 16.1015 23.8985 12.9412 20 12.9412C16.1015 12.9412 12.9412 16.1015 12.9412 20C12.9412 23.8985 16.1015 27.0588 20 27.0588C23.8985 27.0588 27.0588 23.8985 27.0588 20ZM28 20C28 24.4183 24.4183 28 20 28C15.5817 28 12 24.4183 12 20C12 15.5817 15.5817 12 20 12C24.4183 12 28 15.5817 28 20Z"
      fill="currentColor"
    />
    <path
      d="M19.5286 23.9436V19.4619C19.5285 19.2269 19.3381 19.0364 19.1031 19.0364H18.2069C17.947 19.0364 17.7363 18.8257 17.7363 18.5658C17.7363 18.3059 17.947 18.0952 18.2069 18.0952H19.1031C19.8579 18.0952 20.4697 18.7071 20.4698 19.4619V23.9436C20.4698 24.2035 20.2591 24.4141 19.9992 24.4141C19.7395 24.4139 19.5286 24.2033 19.5286 23.9436Z"
      fill="currentColor"
    />
    <path
      d="M20.0001 16.7732C20.1982 16.7732 20.3587 16.6127 20.3587 16.4147C20.3587 16.2167 20.1982 16.0562 20.0001 16.0562C19.8021 16.0562 19.6416 16.2167 19.6416 16.4147C19.6416 16.6127 19.8021 16.7732 20.0001 16.7732Z"
      fill="currentColor"
    />
    <path
      d="M19.9999 16.3024C19.9381 16.3024 19.8879 16.3527 19.8878 16.4145C19.8878 16.4763 19.9381 16.5266 19.9999 16.5266C20.0618 16.5266 20.1121 16.4764 20.1121 16.4145C20.112 16.3527 20.0618 16.3024 19.9999 16.3024ZM20.829 16.4145C20.829 16.8724 20.4579 17.2435 19.9999 17.2435C19.5421 17.2435 19.1709 16.8724 19.1709 16.4145C19.1709 15.9566 19.5421 15.5855 19.9999 15.5854C20.4578 15.5854 20.8289 15.9566 20.829 16.4145Z"
      fill="currentColor"
    />
  </svg>
)

export const PersonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      d="M8.17386 0.503906C9.94649 0.593706 11.3565 2.06043 11.3565 3.85547C11.3561 5.70778 9.85429 7.20961 8.00198 7.20996C6.14931 7.20996 4.64686 5.70792 4.64651 3.85547L4.65042 3.68262C4.74023 1.90995 6.20702 0.5 8.00198 0.5L8.17386 0.503906Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.30784 9.48828C11.4621 9.60662 14.1488 11.5431 15.3606 14.2803C15.7635 15.1914 15.269 16.2579 14.2961 16.5645C12.6766 17.0747 10.5339 17.5361 8.0012 17.5361C5.46849 17.5361 3.32584 17.0748 1.70628 16.5645C0.733631 16.258 0.238348 15.1927 0.64085 14.2803H0.641827C1.89272 11.4548 4.71519 9.48248 8.0012 9.48242L8.30784 9.48828Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ShieldCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      d="M6.6001 8.96846L7.8251 10.5843C7.87163 10.6486 7.93403 10.7018 8.00711 10.7392C8.08019 10.7767 8.16184 10.7975 8.24529 10.7998C8.32874 10.8021 8.41159 10.7859 8.48695 10.7525C8.5623 10.7192 8.62801 10.6696 8.6786 10.608L12.6001 6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.82838 1.19946C2.55558 1.19946 2.29396 1.30903 2.10107 1.50407C1.90817 1.69911 1.7998 1.96364 1.7998 2.23947V8.47948C1.7998 11.8165 6.76026 15.53 8.44643 16.6331C8.61102 16.7417 8.80329 16.7995 8.9998 16.7995C9.19632 16.7995 9.38859 16.7417 9.55318 16.6331C11.2393 15.53 16.1998 11.8165 16.1998 8.47948V2.23947C16.1998 2.10289 16.1732 1.96765 16.1215 1.84147C16.0698 1.71529 15.9941 1.60065 15.8985 1.50407C15.803 1.4075 15.6896 1.33089 15.5649 1.27863C15.4401 1.22636 15.3063 1.19946 15.1712 1.19946H2.82838Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BagIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      d="M9.22853 0.504883C11.4147 0.600681 13.2312 2.16211 13.2315 4.27637V4.91992H14.9248C15.7314 4.91999 16.2897 5.46232 16.3555 6.04492L17.3487 14.8604L17.4922 16.1318L17.499 16.249C17.5007 16.4827 17.4286 16.7127 17.2793 16.917L17.1983 17.0166C16.9317 17.3143 16.5215 17.5 16.0615 17.5H1.93654C1.53204 17.4999 1.16816 17.3573 0.905293 17.1221L0.89455 17.1123L0.818378 17.0361L0.807636 17.0244L0.796894 17.0137C0.565451 16.7516 0.471301 16.4391 0.507832 16.126V16.125L1.70607 6.03809C1.77487 5.4594 2.33408 4.92013 3.13478 4.91992H4.79885V4.27637C4.79911 2.19639 6.74822 0.5 9.01564 0.5L9.22853 0.504883Z"
      stroke="currentColor"
    />
    <path d="M5.23531 4.94678H12.8544" stroke="currentColor" />
  </svg>
)

export const BriefcaseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16.8203" height="14.7109" viewBox="0 0 16.8203 14.7109" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      d="M1.55469 3.66406H15.2656C15.2656 3.66406 16.3203 3.66406 16.3203 4.71875V13.1562C16.3203 13.1562 16.3203 14.2109 15.2656 14.2109H1.55469C1.55469 14.2109 0.5 14.2109 0.5 13.1562V4.71875C0.5 4.71875 0.5 3.66406 1.55469 3.66406Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5742 3.66406C11.5742 2.8249 11.2409 2.02011 10.6475 1.42673C10.0541 0.833356 9.24932 0.5 8.41016 0.5C7.57099 0.5 6.7662 0.833356 6.17283 1.42673C5.57945 2.02011 5.24609 2.8249 5.24609 3.66406"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M0.5 7.88281H6.82812" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.99219 7.88281H16.3203" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.82812 8.58594C6.82813 9.00552 6.9948 9.40791 7.29149 9.7046C7.58818 10.0013 7.99058 10.168 8.41016 10.168C8.82974 10.168 9.23213 10.0013 9.52882 9.7046C9.82551 9.40791 9.99219 9.00552 9.99219 8.58594V7.74219C9.99219 7.32261 9.82551 6.92021 9.52882 6.62352C9.23213 6.32683 8.82974 6.16016 8.41016 6.16016C7.99058 6.16016 7.58818 6.32683 7.29149 6.62352C6.9948 6.92021 6.82812 7.32261 6.82812 7.74219V8.58594Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ForwardChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      transform="rotate(-90 11 11)"
      d="M5.64645 8.38425C5.45119 8.56323 5.45119 8.85337 5.64645 9.03237L10.6464 13.6158C10.8418 13.7947 11.1582 13.7947 11.3536 13.6158L16.3535 9.03237C16.5489 8.85337 16.5489 8.56323 16.3535 8.38425C16.1583 8.20525 15.8417 8.20525 15.6465 8.38425L11 12.6436L6.35348 8.38425C6.15822 8.20525 5.84171 8.20525 5.64645 8.38425Z"
      fill="currentColor"
    />
  </svg>
)

export const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      transform="rotate(-90 12 12)"
      d="M19.9396 11.7573C20.0334 11.9367 20.018 12.1579 19.8929 12.3237L14.4497 19.5384C14.4391 19.5524 14.4274 19.5659 14.4155 19.5788C14.1842 19.8289 13.8646 19.9797 13.5246 19.999C13.5146 19.9995 13.5045 20 13.4945 20L5.17825 20C4.86617 19.9987 4.56708 19.8742 4.34642 19.6535C4.12573 19.4326 4.00095 19.1329 4 18.8205L4 14.4896C4 14.1963 4.23779 13.9586 4.53104 13.9585L8.01602 13.9585C8.53535 13.9585 9.03344 13.7521 9.40067 13.3849C9.76791 13.0176 9.97424 12.5194 9.97424 12C9.97424 11.4806 9.76791 10.9824 9.40067 10.6151C9.03344 10.2479 8.53535 10.0415 8.01602 10.0415L4.53312 10.0415C4.23983 10.0415 4.00207 9.8037 4.00207 9.51037L4.00207 5.17842C4.00312 4.86621 4.12776 4.56725 4.3485 4.34647C4.56924 4.1257 4.86816 4.00105 5.18033 4L13.4945 4C13.5042 4 13.5138 4.00051 13.5235 4.00104C13.8641 4.01987 14.1841 4.17049 14.4155 4.42116L14.4497 4.46162L19.8929 11.6836L19.9396 11.7573ZM5.06209 15.0207L5.06209 18.8174C5.06221 18.8493 5.07484 18.88 5.09735 18.9025C5.11938 18.9245 5.14922 18.9371 5.18033 18.9378L13.4717 18.9378C13.5297 18.9328 13.5834 18.9076 13.6252 18.8672L18.8039 12.0021L13.6262 5.13278C13.5847 5.09217 13.5306 5.06721 13.4727 5.06224L5.18344 5.06224L5.1378 5.07158C5.12356 5.07755 5.11056 5.08638 5.09943 5.09751C5.0771 5.11984 5.06439 5.14998 5.06416 5.18154L5.06416 8.97925L8.01602 8.97925C8.81704 8.97925 9.58519 9.29763 10.1516 9.86411C10.718 10.4306 11.0363 11.1988 11.0363 12C11.0363 12.8012 10.718 13.5694 10.1516 14.1359C9.58519 14.7024 8.81704 15.0207 8.01602 15.0207L5.06209 15.0207Z"
      fill="currentColor"
    />
  </svg>
)

export const MapPinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="12.375" height="15" viewBox="0 0 12.375 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <g transform="translate(0 15) rotate(-90)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8.68549 11.875C4.87423 11.875 1.30534 7.37492 0.563531 6.38024C0.522337 6.32499 0.5 6.25722 0.5 6.1875C0.5 6.11777 0.522337 6.05001 0.563531 5.99476C1.30473 5.00071 4.87423 0.5 8.68549 0.5C11.8963 0.5 14.5 2.87169 14.5 6.1875C14.5 9.50331 11.8963 11.875 8.68549 11.875Z" />
      <path d="M8.8125 3.125C8.00027 3.125 7.22131 3.44766 6.64698 4.02199C6.07265 4.59632 5.75 5.37527 5.75 6.1875C5.75 6.99973 6.07265 7.77868 6.64698 8.35301C7.22131 8.92734 8.00027 9.25 8.8125 9.25C9.62472 9.25 10.4037 8.92735 10.978 8.35301C11.5523 7.77868 11.875 6.99973 11.875 6.1875C11.875 5.37527 11.5523 4.59632 10.978 4.02199C10.4037 3.44766 9.62473 3.125 8.8125 3.125Z" />
    </g>
  </svg>
)

export const IdCardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="39.5" height="27.91" viewBox="0 0 39.5 27.91" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <path
      d="M36.2167 0.75H3.28333C1.88421 0.75 0.75 1.73535 0.75 2.95083V24.9592C0.75 26.1747 1.88421 27.16 3.28333 27.16H36.2167C37.6158 27.16 38.75 26.1747 38.75 24.9592V2.95083C38.75 1.73535 37.6158 0.75 36.2167 0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M34.1902 8.76198L20.7635 8.76198" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M34.1902 16.8681L20.7635 16.8681" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M30.8968 12.815L20.7635 12.815" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M10.7568 13.5749C11.3835 13.5749 11.9961 13.389 12.5171 13.0406C13.038 12.6922 13.4439 12.1971 13.6833 11.6179C13.9227 11.0387 13.9848 10.4016 13.8619 9.78704C13.7389 9.17251 13.4364 8.60829 12.9926 8.1658C12.5488 7.72331 11.9837 7.42244 11.3688 7.30131C10.7539 7.18019 10.1169 7.24421 9.53845 7.48533C8.95998 7.72644 8.46608 8.13387 8.11925 8.65585C7.77243 9.17784 7.58826 9.79095 7.59011 10.4176C7.59011 10.8331 7.67211 11.2444 7.83137 11.6281C7.99062 12.0118 8.22401 12.3602 8.51819 12.6535C8.81237 12.9468 9.16154 13.1792 9.54568 13.3373C9.92982 13.4954 10.3414 13.5762 10.7568 13.5749V13.5749Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8187 17.9711C15.3208 17.1005 14.6089 16.3785 13.7538 15.8768C12.8987 15.375 11.9301 15.1111 10.9444 15.1111C9.95867 15.1111 8.9901 15.375 8.13498 15.8768C7.27986 16.3785 6.56797 17.1005 6.07004 17.9711"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="4.55012" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="7.33683" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="10.1232" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="12.91" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="15.6967" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="18.4834" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="21.2698" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="24.0565" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="26.8432" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="29.6299" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="32.4167" cy="24.2151" r="0.76" fill="currentColor" />
    <circle cx="35.2034" cy="24.2151" r="0.76" fill="currentColor" />
  </svg>
)

export const DocumentsVerifiedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <circle cx="13" cy="13" r="13" className="fill-surface-approved" />
    <g transform="translate(-5.34565 -4.63965)">
      <path d="M12.7121 18.9639L15.7499 22.4065L23.9788 12.8732" className="stroke-fg-approved" strokeWidth={2} strokeLinecap="round" fill="none" />
    </g>
  </svg>
)

export const DocumentsFailedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <circle cx="13" cy="13" r="13" className="fill-surface-sale" />
    <g transform="translate(9 9) scale(0.8)" className="stroke-fg-declined-strong" strokeWidth={2.5} strokeLinecap="round">
      <path d="M1 1L9 9" />
      <path d="M1 9L9 1" />
    </g>
  </svg>
)

const round = (value: number) => Math.round(value * 1000) / 1000

export const InstallmentPieIcon = ({ paid, total, ...props }: { paid: number; total: number } & SVGProps<SVGSVGElement>) => {
  const fraction = paid / total
  const angle = 2 * Math.PI * fraction
  const x = round(10 + 10 * Math.sin(angle))
  const y = round(10 - 10 * Math.cos(angle))
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
      <circle cx="10" cy="10" r="10" className="fill-surface-muted" />
      {paid >= total ? (
        <circle cx="10" cy="10" r="10" className="fill-brand" />
      ) : (
        <path d={`M10 10 L10 0 A10 10 0 ${fraction > 0.5 ? 1 : 0} 1 ${x} ${y} Z`} className="fill-brand" />
      )}
    </svg>
  )
}

export const ReviewingIcon = ({ className }: { className?: string }) => (
  <span aria-hidden className={`bg-surface-brand inline-flex size-12.5 items-center justify-center rounded-full ${className ?? ""}`}>
    <Spinner className="text-fg-inverted size-7.5" />
  </span>
)

export const ApprovedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false" {...props}>
    <circle cx="25" cy="25" r="25" className="fill-surface-approved" />
    <g transform="translate(-10.2801 -8.92239)">
      <path d="M24.4468 36.4687L30.2887 43.0891L46.1134 24.7557" strokeWidth="4" strokeLinecap="round" fill="none" className="stroke-fg-approved" />
    </g>
  </svg>
)
